import {setupAxios} from '../app/modules/auth'
import {API_BASE_URL} from '../utils/contants'
import {api} from './APIMiddlewares'
import { getAttendanceSummary } from './AttendanceAPI'
import axios from "axios";

export async function getAdminDatas() {
  const {token, tenantId} = setupAxios()
  const res = await fetch(API_BASE_URL + `/dashboard/admin`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-tenant-Id': `${tenantId}`,
    },
  })
  return await res.json()
}

export async function getActiveUser(status: string) {
  const {token, tenantId} = setupAxios()
  return await api.get(`/dashboard/admin/users?status=${status}`, token, tenantId, false)
}

export async function getUsersChartStats() {
  const {token, tenantId} = setupAxios()

  const res = await fetch(API_BASE_URL + `/dashboard/users/stats`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-tenant-Id': `${tenantId}`,
    },
  })

  return await res.json()
}

export async function getProjectCategoryStats() {
  const { token, tenantId } = setupAxios()

  const res = await fetch(API_BASE_URL + `/dashboard/projects/category`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "X-tenant-Id": tenantId
    }
  })

  return await res.json()
}

export async function getDepartments() {
  const { token, tenantId } = setupAxios()

  const res = await fetch(API_BASE_URL + `/departments`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "X-tenant-Id": `${tenantId}`,
    },
  })

  return await res.json()
}

export const getEmployeeEvents = async () => {
  const { token, tenantId } = setupAxios();

  const res = await fetch(API_BASE_URL + `/dashboard/employee-events`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "X-tenant-Id": `${tenantId}`,
    },
  });

  return await res.json();
};

export async function getTodayAttendanceSummaryFromAMS() {
  const today = new Date().toISOString().split("T")[0];

  return await getAttendanceSummary({
    startDate: today,
    endDate: today,
  });
}



export const getWeeklyPerformance = async (startDate?: string, endDate?: string) => {
  return await axios.get("/api/v1/dashboard/performance/weekly", {
    params: { startDate, endDate }
  });
};